export default "__VITE_ASSET__145194da__"